import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Config } from '../../common/config';
import naegiftLogo from '../../images/naegift_ko_logo.png';
import appIcon from '../../images/app_icon.png';
import iosBadge from '../../images/ios_black.svg';
import androidBadge from '../../images/android_black.svg';

// 현장 룰렛(/event/roulette, /event/roulette/:promotionNo) — 안내 화면.
// ★2026-10-28: 10/22 결정(B-6)으로 현장 공개 뽑기를 없앴다. 룰렛은 내기프트 앱 공지사항에서
//  로그인한 회원만 참여한다(user-app /event/roulette/:promotionNo → POST /api/user/promotion/game/:no/draw).
//  공개 뽑기 API(POST /api/promotion/game/draw · …/send-link)는 서버에서 400 으로 막혔으므로 여기서는 부르지 않는다.
//  라우트 2개는 이미 인쇄 · 배포한 QR 이 들어오는 주소라 그대로 두고, 이 화면만 안내로 바꾼다.
//  진행 중 게임 이름은 공개 조회(GET …/promotion/game/active)로만 보여 준다(없으면 null → 이름 없이 안내).
//  기록: naegift-api-promotion/docs/promotion-ledger.html §38(B-6), §42
// 헤더/푸터 없음, 한국어 전용(기존 현장 룰렛과 같음).

const ANDROID_STORE = 'https://play.google.com/store/apps/details?id=com.naegift.app';
const IOS_STORE = 'https://apps.apple.com/kr/app/id6791131122';

// promotionNo 가 있으면 `${base}promotion/game/{promotionNo}/active`, 없으면 `${base}promotion/game/active`.
const buildActiveUrl = promotionNo => {
  const url = Config.API_GAME_ACTIVE;
  if (!promotionNo) return url;
  const base = url.replace(/active\/?$/, '');
  return base === url ? url : `${base}${promotionNo}/active`;
};

// 응답이 { data: {...} } 로 감싸져 오는 경우와 최상위로 오는 경우를 모두 받는다.
const unwrapGame = res => {
  const body = res && res.data;
  if (!body || typeof body !== 'object') return null;
  const game = 'data' in body && !('promotionNo' in body) ? body.data : body;
  return game && game.promotionNo ? game : null;
};

const STEPS = [
  { title: '내기프트 앱 설치 · 로그인', desc: '아래 버튼으로 앱을 받아 로그인해 주세요.' },
  { title: '공지사항에서 룰렛 이벤트 열기', desc: '앱 공지사항의 [룰렛 이벤트] 공지를 눌러 주세요.' },
  { title: '[룰렛 하러 가기]', desc: '로그인한 회원 1인 1회 참여할 수 있어요.' },
];

const CSS = `
.rg-page *{box-sizing:border-box;}
.rg-page{min-height:100vh;box-sizing:border-box;padding:32px 20px 40px;background:#6B2B5F;display:flex;justify-content:center;align-items:flex-start;font-family:'Noto Sans KR','Apple SD Gothic Neo','Malgun Gothic',sans-serif;}
.rg-card{display:block;box-sizing:border-box;width:100%;max-width:420px;background:#FFF6E8;border-radius:24px;padding:28px 22px 24px;box-shadow:0 12px 36px rgba(0,0,0,.25);text-align:center;color:#4A3226;}
.rg-logo{height:26px;width:auto;margin:0 auto 18px;display:block;}
.rg-wheel{width:76px;height:76px;margin:0 auto 14px;border-radius:50%;background:conic-gradient(#F5E3B3 0 25%,#F7D2BA 0 50%,#D8CFE8 0 75%,#CFDDCB 0);border:5px solid #E5B84B;box-shadow:0 4px 12px rgba(107,43,95,.25);position:relative;}
.rg-wheel::after{content:'';position:absolute;inset:26px;border-radius:50%;background:#FFF6E8;border:3px solid #E5B84B;}
.rg-title{margin:0 0 8px;font-size:21px;font-weight:800;line-height:1.4;letter-spacing:-.02em;word-break:keep-all;}
.rg-nb{white-space:nowrap;font:inherit;color:inherit;letter-spacing:inherit;}
.rg-sub{margin:0 0 18px;font-size:14px;line-height:1.6;color:#6b5a4f;word-break:keep-all;}
.rg-game{display:inline-block;margin:0 0 18px;padding:6px 12px;border-radius:999px;background:#fff;border:1px solid #ecd9c3;font-size:13px;font-weight:700;color:#6B2B5F;word-break:keep-all;}
.rg-steps{list-style:none;margin:0 0 20px;padding:0;text-align:left;}
.rg-step{display:flex;gap:12px;align-items:flex-start;padding:12px 0;border-top:1px dashed #e6d3bd;}
.rg-step:first-child{border-top:none;}
.rg-num{flex:none;width:26px;height:26px;border-radius:50%;background:#6B2B5F;color:#fff;font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center;}
.rg-step-title{margin:2px 0 2px;font-size:15px;font-weight:700;}
.rg-step-desc{margin:0;font-size:13px;line-height:1.5;color:#7a685c;word-break:keep-all;}
.rg-app{display:flex;align-items:center;justify-content:center;gap:8px;margin:0 0 12px;font-size:13px;font-weight:700;color:#4A3226;}
.rg-app img{width:28px;height:28px;border-radius:7px;}
.rg-badges{display:flex;gap:8px;justify-content:center;flex-wrap:wrap;}
.rg-badges a{display:block;}
.rg-badges img{height:42px;width:auto;display:block;}
.rg-note{margin:18px 0 0;font-size:12px;color:#9a8678;line-height:1.5;word-break:keep-all;}
`;

export default function Roulette() {
  const { promotionNo } = useParams();
  const [gameName, setGameName] = useState(null);

  // 진행 중 게임 이름만 보여 준다(선택). 실패하거나 없으면 이름 없이 안내.
  useEffect(() => {
    let cancelled = false;
    axios
      .get(buildActiveUrl(promotionNo), { headers: { Accept: 'application/json' } })
      .then(res => {
        const game = unwrapGame(res);
        if (!cancelled) setGameName(game && game.gameState !== 'CLOSED' ? game.name || null : null);
      })
      .catch(() => {
        if (!cancelled) setGameName(null);
      });
    return () => {
      cancelled = true;
    };
  }, [promotionNo]);

  return (
    <div className="rg-page">
      <style>{CSS}</style>
      <div className="rg-card">
        <img className="rg-logo" src={naegiftLogo} alt="내기프트" />
        <div className="rg-wheel" aria-hidden />
        <h1 className="rg-title">
          룰렛 이벤트는
          <br />
          내기프트 앱에서 <span className="rg-nb">참여할 수 있어요</span>
        </h1>
        <p className="rg-sub">현장 룰렛은 종료되었어요. 내기프트 앱 공지사항에서 참여해 주세요.</p>
        {gameName && <div className="rg-game">진행 중 · {gameName}</div>}

        <ol className="rg-steps">
          {STEPS.map((s, i) => (
            <li key={s.title} className="rg-step">
              <span className="rg-num">{i + 1}</span>
              <div>
                <p className="rg-step-title">{s.title}</p>
                <p className="rg-step-desc">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="rg-app">
          <img src={appIcon} alt="" />
          내기프트 앱 받기
        </div>
        <div className="rg-badges">
          <a href={IOS_STORE}>
            <img src={iosBadge} alt="App Store에서 다운로드" />
          </a>
          <a href={ANDROID_STORE}>
            <img src={androidBadge} alt="Google Play에서 다운로드" />
          </a>
        </div>
        <p className="rg-note">이미 앱이 있다면 앱을 열고 공지사항으로 이동해 주세요.</p>
      </div>
    </div>
  );
}
